import styled from 'styled-components';

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 200px;
`;

export default LoaderContainer;
